import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { TenantRepository } from "../../repositories";
import { FeatureConfiguration } from "../../domain/models/feature-configuration";

@Injectable({ providedIn: 'root' })
export class GetFeatureConfigurationUsecase implements UseCase<null,FeatureConfiguration[]> {

  constructor(private readonly tenantRepository: TenantRepository) {
  }

  execute(): Observable<FeatureConfiguration[]> {
    return this.tenantRepository.getFeatureConfigurations();
  }

}